<template>
  <div class="container my-5">
    <c-data-list ref="dataList" :items="stack.invoices">
        <template v-slot:columns>
          <div class="col-12 col-lg-4 col-xl-4">
            <p>Invoice No</p>
          </div>
          <div class="col-12 col-lg-4 col-xl-4">
            <p>Month</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2">
            <p>Status</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2 text-end">Auto Bill</div>
        </template>
        <template v-slot:default="slotProps">
          <invoices-list-item :invoice="slotProps.item" />
        </template>
      </c-data-list>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import StacksModal from "./StacksModal";
import InvoicesListItem from "./InvoicesListItem"

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  components: {
    StacksModal,
    InvoicesListItem
  },
  data: function () {
    return {
      loaded: false
    };
  },
  computed: {
    ...mapState("stack", {
      stack: "single",
    }),
    awsLink() {
      return 'https://signin.aws.amazon.com/switchrole?roleName=OrganizationAccountAccessRole&account='+this.stack.aws_account_id+'&displayName='+this.stack.terraform_workspace_name+'&color=FBBF93'
    }
  },

  methods: {
    ...mapActions("stack", {
      getStack: "getSingle",
      updateSingle: "updateSingle",
      deleteSingle: "deleteSingle",
    }),

    confirmDelete() {
      this.$swal({
        title: "Confirm Delete",
        html: "Are you sure you want to delete this stack",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then(
        () => {
          this.deleteSingle(this.stack.id).then(
            this.$router.push({ name: "stacks.index" })
          );
        },
        function () {}
      );
    },
  },
};
</script>
